









import { defineComponent, PropType, ref } from "@vue/composition-api";
import { InputPayeeInformation, PayeeInformation } from "@scrile/api-provider/dist/api/PayeeInformationProvider";
import { FormValues } from "@/types";
import BaseForm from "@/components/BaseForm";
import { systemName, formFields } from "./config";

export default defineComponent({
  name: "PayPalPayout",
  components: { BaseForm },
  props: {
    savedValues: { type: Object as PropType<Partial<InputPayeeInformation>>, required: true },
    payeeInformation: { type: Object as PropType<PayeeInformation | null> },
  },
  setup(props, { emit }) {
    const values = ref<FormValues>({
      account: props.savedValues.paypal?.account || props.payeeInformation?.paypal?.account || undefined,
    });

    const sendInput = () => {
      const data: Partial<InputPayeeInformation> = {
        [systemName]: {
          account: values.value.account || "",
        },
      };
      emit("input", data);
    };
    const input = (newValues: FormValues) => {
      values.value = newValues;
      sendInput();
    };

    sendInput();

    return { values, formFields, input };
  },
});
